import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const TicketAdvancedLayout = styled(Paper)({
    height: `calc(100% - 48px)`,
    minHeight: 0,
    overflow: "hidden",
    display: "grid",
    gridTemplateRows: "56px minmax(0, 1fr)"
})

export default TicketAdvancedLayout;